<template>
  <v-container id="info-bar">
    <span><b>Stakeholder:</b> {{ stakeholder }}</span>
    <br
      v-if="$vuetify.breakpoint.xs"
    >
    <v-divider
      v-else
      class="mx-3"
      inset
      vertical
    />
    <span><b>Project:</b> {{ project }}</span>
    <br
      v-if="$vuetify.breakpoint.xs"
    >
    <v-divider
      v-else
      class="mx-3"
      inset
      vertical
    />
    <span><b>Topic:</b> {{ topic }}</span>
  </v-container>
</template>

<script>
export default {
  name: "Info",
  props: {
    stakeholder: {
      type: String,
      default: ""
    },
    project: {
      type: String,
      default: ""
    },
    topic: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
#info-bar {
  text-align: center;
}
span {
  font-size: 1.75em;
}
@media (min-width: 320px) and (max-width: 1023px) {
  span {
    font-size: 1.25em;
  }
  #info-bar {
    text-align: left;
  }
}

</style>
